import clsx from "clsx";
import { renderizarMarkdownSeguro } from "../utils/renderizarMarkdown";

type MarkdownMessageProps = {
	readonly conteudo: string;
	readonly className?: string;
};

// Renderiza o Markdown do assistente como HTML sanitizado, com tipografia compacta que
// herda a cor de texto da bolha (funciona em tema claro/escuro) e permite rolagem
// horizontal em tabelas/blocos de código sem estourar o layout.
export default function MarkdownMessage({ conteudo, className }: MarkdownMessageProps) {
	return (
		<div
			className={clsx(
				"prose prose-sm max-w-none leading-relaxed [&_*]:text-sm",
				"prose-headings:mb-1 prose-headings:mt-3 prose-headings:font-semibold first:prose-headings:mt-0",
				"prose-p:my-1.5 prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5",
				"prose-pre:overflow-x-auto prose-pre:bg-muted/60 prose-code:text-current",
				"prose-table:block prose-table:overflow-x-auto prose-a:text-secondary",
				className,
			)}
			dangerouslySetInnerHTML={{ __html: renderizarMarkdownSeguro(conteudo) }}
		/>
	);
}
